<template>
  <div id="app">
    <div class="print-container">
      <pdf-content
        key="print-container"
        :loan_type="loan_type"
        :date_range="date_range"
        :loanTypeOptions="loanTypeOptions"
        :report-list="reportList"
        :loading="loading"
      />
    </div>
    <b-modal id="modal-print" size="lg" title="" hide-footer>
      <pdf-content
        :loan_type="loan_type"
        :date_range="date_range"
        :loanTypeOptions="loanTypeOptions"
        :report-list="reportList"
        :loading="loading"
      />
      <div class="modal-footer d-flex justify-content-center">
        <button class="btn btn-primary" @click="downloadPdf">列印</button>
      </div>
    </b-modal>
    <div class="report-container">
      <div class="filter-form">
        <h2 class="report-title">報表 » 貸款還清報表</h2>
        <div class="form-group">
          <label>篩選項目</label>
        </div>

        <div class="form-group">
          <label>還款日期</label>
          <div class="date-range">
            <input type="date" v-model="date_range.from" />
            <span>至</span>
            <input type="date" v-model="date_range.to" />
            <div class="date-controls">
              <div class="date-nav">
                <button class="nav-btn" @click="handleDateChange('年', 'left')">
                  <feather-icon icon="ChevronLeftIcon"></feather-icon>
                </button>
                <button class="period-btn" @click="setDateRange('年')">
                  年
                </button>
                <button
                  class="nav-btn"
                  @click="handleDateChange('年', 'right')"
                >
                  <feather-icon icon="ChevronRightIcon"></feather-icon>
                </button>
              </div>
              <div class="date-nav">
                <button class="nav-btn" @click="handleDateChange('月', 'left')">
                  <feather-icon icon="ChevronLeftIcon"></feather-icon>
                </button>
                <button class="period-btn" @click="setDateRange('月')">
                  月
                </button>
                <button
                  class="nav-btn"
                  @click="handleDateChange('月', 'right')"
                >
                  <feather-icon icon="ChevronRightIcon"></feather-icon>
                </button>
              </div>
              <div class="date-nav">
                <button class="nav-btn" @click="handleDateChange('日', 'left')">
                  <feather-icon icon="ChevronLeftIcon"></feather-icon>
                </button>
                <button class="period-btn" @click="setDateRange('日')">
                  日
                </button>
                <button
                  class="nav-btn"
                  @click="handleDateChange('日', 'right')"
                >
                  <feather-icon icon="ChevronRightIcon"></feather-icon>
                </button>
              </div>
              <div class="date-nav">
                <button class="nav-btn" @click="handleDateChange('週', 'left')">
                  <feather-icon icon="ChevronLeftIcon"></feather-icon>
                </button>
                <button class="period-btn" @click="setDateRange('週')">
                  週
                </button>
                <button
                  class="nav-btn"
                  @click="handleDateChange('週', 'right')"
                >
                  <feather-icon icon="ChevronRightIcon"></feather-icon>
                </button>
              </div>
            </div>
          </div>
        </div>

        <div class="form-group">
          <label>貸款類別</label>
          <select v-model="loan_type_id" class="form-select">
            <option selected value="">全部</option>
            <option
              v-for="option in loanTypeOptions"
              :key="option.id"
              :value="option.id"
            >
              {{ option.name }}
            </option>
          </select>
        </div>


        <div class="form-actions">
          <button class="btn btn-primary" @click="handleModalPrint">
            報表
          </button>
          <button class="btn btn-default" @click="resetFilter">重設</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PdfContent from "./PdfContent";
import { ref, onUnmounted } from "@vue/composition-api";
import store from "@/store";
import axiosIns from "@/libs/axios";

export default {
  name: "app",

  data() {
    return {
      contentRendered: false,
      progress: 0,
      generatingPdf: false,
      pdfDownloaded: false,
    };
  },
  setup() {
    const reportList = ref([]);
    const reportData = ref({});
    const loading = ref(false);
    const date_range = ref({
      from: "",
      to: "",
    });
    const loan_type_id = ref("");

    const refetchData = () => {
      loading.value = true;
      axiosIns
        .get("/report/loan-cleared-statement", {
          params: {
            last_pay_date_from: date_range.value.from,
            last_pay_date_to: date_range.value.to,
            loan_type_id: loan_type_id.value,
            orderBy: "receipt_date",
            sortDesc: 1,
          },
        })
        .then((response) => {
          reportList.value = response.data.data;
          loading.value = false;
        })
        .catch((error) => {
          if (error.response.status === 404) {
            reportList.value = undefined;
          }
          loading.value = false;
        });
    };

    const loanTypeOptions = ref([]);

    const refetchOption = () => {
      store
        .dispatch("app/fetchOptionList", {
          loan_type: true,
        })
        .then((response) => {
          loanTypeOptions.value = response.data.loan_types;
        });
    };

    refetchOption();
    // refetchData();

    return {
      reportList,
      reportData,
      refetchData,
      loanTypeOptions,
      date_range,
      loan_type_id,
      loading,
    };
  },
  mounted(){
    this.setDateRange("年");
  },

  computed: {
    loan_type(){
      return this.loanTypeOptions.find(ele => ele.id == this.loan_type_id)?.name;
    }
  },

  methods: {
    downloadPdf() {
      // 设置默认文件名
      const defaultFileName = `貸款還清報表_${new Date().toISOString().slice(0,10)}`;
      // 提示用户输入文件名
      // const fileName = window.prompt('請輸入文件名稱:', defaultFileName);
      
      // if (fileName) {
        // 设置打印时的文件名
        const style = document.createElement('style');
        style.innerHTML = `
          @page {
            margin: 0mm 10mm;
          }
          @media print {
            html, body {
              height: 100%;
            }
          }
        `;
        document.head.appendChild(style);
        
        window.document.title = defaultFileName;
        window.print();
        
        // 打印完成后恢复原标题
        setTimeout(() => {
          document.head.removeChild(style);
          window.document.title = 'X Data';
        }, 100);
      // }
    },

    handleDateChange(type, direction) {
      const { from, to } = this.date_range;
      let fromDate = new Date(from);
      let toDate = new Date(to);

      switch (type) {
        case "年":
          const yearChange = direction === "left" ? -1 : 1;
          fromDate.setFullYear(fromDate.getFullYear() + yearChange);
          toDate.setFullYear(toDate.getFullYear() + yearChange);
          break;

        case "月":
          const monthChange = direction === "left" ? -1 : 1;
          fromDate.setMonth(fromDate.getMonth() + monthChange);
          toDate.setMonth(toDate.getMonth() + monthChange);
          break;

        case "日":
          const dayChange = direction === "left" ? -1 : 1;
          fromDate.setDate(fromDate.getDate() + dayChange);
          toDate.setDate(toDate.getDate() + dayChange);
          break;

        case "週":
          const weekChange = direction === "left" ? -7 : 7;
          fromDate.setDate(fromDate.getDate() + weekChange);
          toDate.setDate(toDate.getDate() + weekChange);
          break;
      }

      // 更新日期範圍
      this.date_range = {
        from: this.formatDate(fromDate),
        to: this.formatDate(toDate),
      };
    },

    formatDate(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    },

    // 設置日期範圍
    setDateRange(type) {
      const today = new Date();
      let fromDate = new Date();
      let toDate = new Date();

      switch (type) {
        case "年":
          // 設置為當年的 1月1日 到 12月31日
          fromDate = new Date(today.getFullYear(), 0, 1);
          toDate = new Date(today.getFullYear(), 11, 31);
          break;

        case "月":
          // 設置為當月的 1日 到 月末
          fromDate = new Date(today.getFullYear(), today.getMonth(), 1);
          toDate = new Date(today.getFullYear(), today.getMonth() + 1, 0);
          break;

        case "日":
          // 設置為今天
          fromDate = today;
          toDate = today;
          break;

        case "週":
          // 設置為本週的週一到週日
          const day = today.getDay() || 7;
          fromDate = new Date(today.setDate(today.getDate() - day));
          toDate = new Date(today.setDate(today.getDate() + 6));
          break;
      }

      this.date_range = {
        from: this.formatDate(fromDate),
        to: this.formatDate(toDate),
      };
    },

    handleModalPrint() {
      this.reportList = []
      this.refetchData();
      this.$bvModal.show("modal-print");
    },

    resetFilter() {
      this.loan_type_id = "";
      this.setDateRange("年");
    },
  },

  components: {
    PdfContent,
  },
};
</script>

<style lang="scss" scoped>
</style>